import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

const BASE_API_HOST = `https://${process.env.APP_ENV}-api.sidecarhealth.com`

// `service` is a tag, NOT the RUM application. The application is
// `DATADOG_APPLICATION_ID` (the `sidecar-member-app` RUM app); this SPA and the
// member-app shell both report into it, kept apart only by `service`
// (`member-spa` here vs `member-app` in the shell). That's the
// micro-frontend attribution mechanism — don't align them (FALC-1976).
// Monitors and dashboards referencing the old `sidecar-health-member-app`
// service tag must be updated to `member-spa` (WEB-1866).
//
// NODE_ENV gates "should this code run at all" (false in dev/test, true in
// prod builds). APP_ENV selects "which backend/config" (dev, qa, prod).
if (process.env.NODE_ENV === 'production') {
  datadogRum.init({
    applicationId: process.env.DATADOG_APPLICATION_ID,
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'member-spa',
    env: process.env.APP_ENV,
    version:
      process.env.APP_VERSION_SHA ||
      process.env.VERCEL_GIT_COMMIT_SHA ||
      'unknown',
    sessionSampleRate: process.env.APP_ENV === 'prod' ? 100 : 0,
    sessionReplaySampleRate: 0,
    trackResources: true,
    trackLongTasks: true,
    trackUserInteractions: true,
    trackFrustrations: true,
    traceSampleRate: 100,
    allowedTracingUrls: [
      BASE_API_HOST,
      /https:\/\/.*\.sidecarhealth\.com/,
      url => url.startsWith(BASE_API_HOST),
    ],
  })

  datadogLogs.init({
    clientToken: process.env.DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'member-spa',
    env: process.env.APP_ENV,
    version:
      process.env.APP_VERSION_SHA ||
      process.env.VERCEL_GIT_COMMIT_SHA ||
      'unknown',
    forwardErrorsToLogs: true,
    forwardConsoleLogs: ['error', 'warn'],
    sessionSampleRate: 100,
    beforeSend: log => {
      // Filter out "info" errors, geolocation, and known
      // deprecation warnings.
      if (
        log?.message?.includes('Oops') ||
        log?.message?.toLowerCase().includes('denied geolocation') ||
        log?.message?.includes(
          'google.maps.places.AutocompleteService is not available to new customers',
        )
      ) {
        return false
      }
      return true
    },
  })
}

export const logError = (message, context = {}) => {
  datadogLogs.logger.error(message, context)
}
